import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store/";
import "./registerServiceWorker";
import "@/assets/styles/reset.scss";
import "@/assets/iconfont/iconfont.css";
import {  Checkbox, CheckboxGroup ,Notify, Dialog, Cell, CellGroup,Uploader, CountDown, Popup, Popover  } from "vant";
import vueTouch from "vue-plugin-touch";
import touch from "vue-directive-touch";
import VueI18n from "vue-i18n";
import "lib-flexible";
import "vant/lib/index.css";
import { lang,messages} from "@/locale/index";
import VideoPlayer from 'vue-video-player'

import 'video.js/dist/video-js.css'
import 'vue-video-player/src/custom-theme.css'

Vue.use(Notify)
  .use(Dialog)
  .use(vueTouch)
  .use(touch)
  .use(Cell)
  .use(Checkbox)
  .use(CheckboxGroup)
  .use(CellGroup)
  .use(Uploader)
  .use(Popover)
  .use(VueI18n)
  .use(Popup )
  .use(VueI18n)
  .use(VideoPlayer);

const i18n = new VueI18n({
  locale:lang, // 将要切换的语言，可以通过url拼的参数获取，用户行为select选择获取，本地manifest配置获取等，根据场景动态获取
  messages
})
Vue.config.productionTip = false;

window.vm = new Vue({
  router,
  i18n,
  store,
  render: (h) => h(App),
}).$mount("#app");
